import React from "react";

export default function AppAds() {

  return (
    <>
    <h1 style={{marginTop:"50px"}}>google.com, pub-4411766249054492, DIRECT, f08c47fec0942fa0</h1>
    </>
  );
}
